import { useState } from 'react';
import { message } from 'antd';
import { adminService, UserCreditSummary } from '../../api/services/adminService';

export const useUserCreditSummary = () => {
  const [summary, setSummary] = useState<UserCreditSummary | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchSummary = async (userId: string) => {
    setLoading(true);
    try {
      const result = await adminService.getUserCreditSummary(userId);
      setSummary(result);
    } catch {
      message.error('Failed to load user credit history');
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setSummary(null);
  };

  return { summary, loading, fetchSummary, clear };
};
